<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="openDialog"
      >添加币种</el-button
    >
    <el-dialog
      title="添加币种"
      width="1200px"
      :visible.sync="dialogVisible"
      @close="closeDialog"
    >
      <el-form
        label-width="200px"
        :model="currency"
        :rules="rules"
        ref="currencyForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="币种：" prop="info.coin">
              <el-input
                ref="infoCodRef"
                v-model.trim="currency.info.coin"
                @blur="infoCodeChange(currency.info.coin)"
              ></el-input>
            </el-form-item>
            <el-form-item label="充值：" prop="info.supportDeposit">
              <el-switch
                v-model="currency.info.supportDeposit"
                active-color="#13ce66"
              ></el-switch>
            </el-form-item>
            <el-form-item label="提现：" prop="info.supportWithdraw">
              <el-switch
                v-model="currency.info.supportWithdraw"
                active-color="#13ce66"
              ></el-switch>
            </el-form-item>
            <el-form-item label="Memo Needed：" prop="info.memoNeeded">
              <el-switch
                v-model="currency.info.memoNeeded"
                active-color="#13ce66"
              ></el-switch>
            </el-form-item>
            <el-form-item
              label="是否支持Memo正则表达式："
              prop="info.supportMemoVerify"
              v-if="currency.info.memoNeeded"
            >
              <el-switch
                v-model="currency.info.supportMemoVerify"
                @change="handleRegexpSupportChange($event, 'memoRegexpExpress')"
                active-color="#13ce66"
              ></el-switch>
            </el-form-item>
            <el-form-item
              label="Memo正则表达式："
              prop="info.memoRegexpExpress"
              v-if="currency.info.memoNeeded"
            >
              <el-input
                v-model="currency.info.memoRegexpExpress"
                :disabled="!currency.info.supportMemoVerify"
              ></el-input>
            </el-form-item>
            <el-form-item label="币种全名：" prop="info.coinFullName">
              <el-input v-model="currency.info.coinFullName"></el-input>
            </el-form-item>
            <!-- <el-form-item label="最小交易额：" prop="info.minimumTradeAmount">
              <el-input v-model="currency.info.minimumTradeAmount"></el-input>
            </el-form-item> -->
            <el-form-item label="最小充值额：" prop="info.minimumDepositAmount">
              <el-input-number
                v-model="currency.info.minimumDepositAmount"
                prop="info.minimumDepositAmount"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="提现手续费：" prop="info.withdrawFee">
              <el-input v-model="currency.info.withdrawFee"></el-input>
            </el-form-item>
            <el-form-item label="单笔提现额度：" required>
              <el-col :span="11">
                <el-form-item prop="info.minWithdrawSingle">
                  <el-input
                    v-model="currency.info.minWithdrawSingle"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col class="text-center" :span="2">~</el-col>
              <el-col :span="11">
                <el-form-item prop="info.maxWithdrawSingle">
                  <el-input
                    v-model="currency.info.maxWithdrawSingle"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label="当日提现额度：" prop="info.maxWithdrawOneDay">
              <el-input v-model="currency.info.maxWithdrawOneDay"></el-input>
            </el-form-item>
            <el-form-item label="确认数：" prop="info.blockConfirm">
              <el-input v-model="currency.info.blockConfirm"></el-input>
            </el-form-item>
            <el-form-item label="区块时间：" prop="info.blockTime">
              <el-input v-model="currency.info.blockTime"></el-input>
            </el-form-item>
            <el-form-item
              label="区块链浏览器hash："
              prop="info.blockChainHashBuilder"
              ref="blockChainHashBuilder"
            >
              <el-input
                v-model="currency.info.blockChainHashBuilder"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="区块链浏览器addr："
              prop="info.blockChainAddrBuilder"
            >
              <el-input
                v-model="currency.info.blockChainAddrBuilder"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="是否支持地址正则表达式："
              prop="info.supportAddrVerify"
            >
              <el-switch
                v-model="currency.info.supportAddrVerify"
                @change="handleRegexpSupportChange($event, 'addrRegexpExpress')"
                active-color="#13ce66"
              ></el-switch>
            </el-form-item>
            <el-form-item
              label="地址正则表达式："
              prop="info.addrRegexpExpress"
            >
              <el-input
                v-model="currency.info.addrRegexpExpress"
                :disabled="!currency.info.supportAddrVerify"
              ></el-input>
            </el-form-item>
            <el-form-item label="描述：">
              <el-input
                v-model="currency.info.desc"
                :autosize="{ minRows: 4, maxRows: 6 }"
                type="textarea"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="代币类型：">
              <el-select
                v-model="currencyType"
                placeholder="请选择币种类型"
                clearable
                @change="handleCurrencySelect"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="12">
            <el-form-item label="是否EOS或EOS代币：" prop="eosSerious">
              <el-switch
                v-model="currency.eosSerious"
                @change="handleIsEosSeriousChange"
                active-color="#13ce66"
              ></el-switch>
            </el-form-item>

            <el-form-item
              label="生成代币账户："
              prop="eosSeriousConfig.contractIdentify"
              :rules="[
                { message: '请输入代币标识', required: currency.eosSerious },
              ]"
            >
              <el-input
                v-model="currency.eosSeriousConfig.contractIdentify"
                :disabled="!currency.eosSerious"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="代币精度："
              prop="eosSeriousConfig.precision"
              :rules="[
                { message: '请输入EOS代币精度', required: currency.eosSerious },
              ]"
            >
              <el-input
                v-model="currency.eosSeriousConfig.precision"
                :disabled="!currency.eosSerious"
              ></el-input>
            </el-form-item>
          </el-col> -->

          <el-col :span="12">
            <!-- <el-form-item label="是否支持红包：">
              <el-switch
                v-model="currency.info.supportRedPacket"
                active-color="#13ce66"
              ></el-switch>
            </el-form-item>
            <el-form-item label="单个红包最大金额：">
              <el-input-number
                v-model="currency.info.maxRedPacketAmount"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="单个红包最小金额：">
              <el-input-number
                v-model="currency.info.minRedPacketAmount"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="红包金额精度：">
              <el-input-number
                v-model="currency.info.redPacketAmountPrecision"
              ></el-input-number>
            </el-form-item> -->
            <!-- <el-form-item label="社区二维码：" prop="info.communityURL">
              <upload v-model="currency.info.communityURL"></upload>
            </el-form-item>
            <el-form-item label="聊天室ID：" prop="info.groupId">
              <el-input v-model="currency.info.groupId"></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="chains：" prop="info.chains" v-if="currency.info.code!='USDT'">
              <el-input
                type="primary"
                placeholder="请输入币种链名称（大写）"
                v-model="chain"
              ></el-input>
            </el-form-item> -->
            <el-form-item label="chain：" prop="info.chain" >
              <!-- <el-input
                type="primary"
                placeholder="请输入币种链名称（大写）"
                v-model="chain"
              ></el-input> -->
              <el-select v-model="currency.info.chain" placeholder="请选择">
                <el-option
                  v-for="item in chainsData2"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="source：" prop="info.source">
              <el-select v-model="currency.info.source" placeholder="请选择">
                <el-option
                  v-for="item in options2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="addressSource" prop="info.addressSource">
              <el-select v-model="currency.info.addressSource" placeholder="请选择">
                <el-option
                  v-for="item in sourceAddressData2"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="udMainCoinType" prop="info.udMainCoinType">
              <el-select clearable v-model="currency.info.udMainCoinType" placeholder="请选择">
                <el-option
                  v-for="item in udData"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="udCoinType" prop="info.udCoinType">
              <el-select clearable v-model="currency.info.udCoinType" placeholder="请选择">
                <el-option
                  v-for="item in udData"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave('currencyForm')"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import {
  ERC20_CONFIG,
  TRC20_CONFIG,
  BSC_CONFIG,
  EOS_SERIOUS_CONFIG,
} from "../../constants";
import Upload from "components/upload";

export default {
  name: "CreateCurrency",
  data() {
    return {
      value:'',
      chainsArr: [],
      chainsData2:[],
      sourceAddressData2:[],
      chain: "",
      options: [
        {
          value: "erc20",
          label: "ERC20代币",
        },
        {
          value: "trc20",
          label: "TRC20代币",
        },
        {
          value: "bsc",
          label: "BSC代币",
        },
        {
          value: "other",
          label: "其他",
        },
      ],
      options2: [
        {
          value: "wallet",
          label: "wallet",
        },
        {
          value: "cobo",
          label: "cobo",
        },
        {
          value: "HDWallet",
          label: "HDWallet",
        },
      ],
      value2: "wallet",
      coin: "",
      currencyType: "",
      dialogVisible: false,
      currency: {
        info: {
          chain: "",
          source:''
        },
        eosSerious: false,
        eosSeriousConfig: {},
      },
      rules: {
        "info.coin": [{ required: true, message: "请输入币种名称" }],
        "info.source": [{ required: true, message: "请选择" }],
        "info.chain": [{ required: true, message: "请选择币种链名称" }],
        "info.maxWithdrawOneDay": [
          { required: true, message: "请输入当日提现额度" },
        ],
        "info.maxWithdrawSingle": [
          { required: true, message: "请输入单笔提现最大额度" },
        ],
        "info.coinFullName": [{ required: true, message: "请输入币种全名" }],
        "info.minWithdrawSingle": [
          { required: true, message: "请输入单笔提现最小额度" },
        ],
        "info.minimumTradeAmount": [
          { required: true, message: "请输入最小交易额" },
        ],
        "info.minimumDepositAmount": [
          { required: true, message: "请输入最小充值额" },
        ],
        "info.withdrawFee": [{ required: true, message: "请输入提现手续费" }],
        "info.blockConfirm": [{ required: true, message: "请输入确认数" }],
        "info.blockTime": [{ required: true, message: "请输入区块时间" }],
        "info.blockChainHashBuilder": [
          { required: true, message: "请输入区块链浏览器hash地址" },
        ],
        "info.blockChainAddrBuilder": [
          { required: true, message: "请输入区块链浏览器address地址" },
        ],
      },
    };
  },
  components: {
    Upload,
  },
  computed: {
    ...mapState('currencySetting',['chainsData','sourceAddressData','udData'])
  },
  watch: {
    chainsData() {
      if (this.dialogVisible) {
        this.syncSelectOptions();
      }
    },
    sourceAddressData() {
      if (this.dialogVisible) {
        this.syncSelectOptions();
      }
    },
  },
  methods: {
    ...mapActions("currencySetting", ["create"]),
    openDialog() {
      this.syncSelectOptions();
      this.dialogVisible = true;
    },
    syncSelectOptions() {
      this.chainsData2 = [...this.chainsData];
      this.sourceAddressData2 = [...this.sourceAddressData];
    },
    handleSave(formName) {
     
      let obj={}
      // if(this.currency.info.code=='USDT'){
      //   obj={...this.currency,info:{...this.currency.info,chains:[this.value]}}
      // }else{
      //   obj={...this.currency,info:{...this.currency.info,chains:[this.chain]}}
      // }
      obj={...this.currency,info:{...this.currency.info,chain:this.currency.info.chain}}

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.create(obj).then(() => {
            this.$message.success("添加成功！");
            this.dialogVisible = false;
            this.$emit("refresh", { page: 1 });
          });
        }
      });
    },
    infoCodeChange(e) {
      this.currency.info.chain = "";
      this.chain = e || "";
      this.syncSelectOptions();
    },
    closeDialog() {
      this.currency = {
        info: {
          chain: "",
        },
        eosSerious: false,
        eosSeriousConfig: {},
      };
      this.syncSelectOptions();
      this.$refs["currencyForm"].resetFields();
      // this.$refs["currencyForm"].clearValidate();
    },
    handleRegexpSupportChange(isSupported, key) {
      if (!isSupported) {
        this.currency = {
          ...this.currency,
          info: {
            ...this.currency.info,
            [key]: "",
          },
        };
      }
    },
    handleCurrencySelect(value) {
      if (value === "erc20") {
        this.currency = {
          ...this.currency,
          info: {
            ...this.currency.info,
            blockChainHashBuilder: ERC20_CONFIG.hash,
            blockChainAddrBuilder: ERC20_CONFIG.address,
            supportAddrVerify: true,
            addrRegexpExpress: ERC20_CONFIG.regexp,
          },
        };
      } else if (value === "trc20") {
        this.currency = {
          ...this.currency,
          info: {
            ...this.currency.info,
            blockChainHashBuilder: TRC20_CONFIG.hash,
            blockChainAddrBuilder: TRC20_CONFIG.address,
            supportAddrVerify: true,
            addrRegexpExpress: "",
          },
        };
      } else if (value === "bsc") {
        this.currency = {
          ...this.currency,
          info: {
            ...this.currency.info,
            blockChainHashBuilder: BSC_CONFIG.hash,
            blockChainAddrBuilder: BSC_CONFIG.address,
            supportAddrVerify: true,
            addrRegexpExpress: BSC_CONFIG.regexp,
          },
        };
      } else {
        this.currency = {
          ...this.currency,
          info: {
            ...this.currency.info,
            blockChainHashBuilder: "",
            blockChainAddrBuilder: "",
            supportAddrVerify: false,
            addrRegexpExpress: "",
          },
        };
      }
    },
    handleIsEosSeriousChange(isEosSerious) {
      if (isEosSerious) {
        this.currency = {
          ...this.currency,
          info: {
            ...this.currency.info,
            memoNeeded: true,
            blockChainHashBuilder: EOS_SERIOUS_CONFIG.hash,
            blockChainAddrBuilder: EOS_SERIOUS_CONFIG.address,
            supportAddrVerify: true,
            addrRegexpExpress: EOS_SERIOUS_CONFIG.regexp,
            blockConfirm: 1,
            blockTime: 2,
          },
        };
      } else {
        this.currency = {
          ...this.currency,
          info: {
            ...this.currency.info,
            memoNeeded: false,
            blockChainHashBuilder: "",
            blockChainAddrBuilder: "",
            supportAddrVerify: false,
            addrRegexpExpress: "",
            blockConfirm: "",
            blockTime: "",
          },
        };
      }
    },
  },
};
</script>

<style lang="less" scoped></style>
